<template>
  <div>
    <!-- 根据currentPage显示不同的组件 -->
    <Login v-if="currentPage === 'login'" @switch-to-register="switchToRegister" @switch-to-home="switchToHome" />
    <Register v-else-if="currentPage === 'register'" @switch-to-login="switchToLogin" />
    <Home v-else-if="currentPage === 'home'" />
    <ScoreLookup v-else-if="currentPage === 'score-lookup'" />
    <ExamDetailPage v-else-if="currentPage === 'exam-detail'" :id="examId" />
    <AdmissionTicketPage v-else-if="currentPage === 'ticket'" :exam-id="examId" />
    <AdmitCardPrint v-else-if="currentPage === 'admit-card'" :exam-id="examId" />
    <ExamRegisterPage v-else-if="currentPage === 'exam-register'" :exam-id="examId" @back="switchToHome" />
    <AnnouncementDetail v-else-if="currentPage === 'announcement'" :id="announcementId" @back="switchToHome" />
    <SectionDetail v-else-if="currentPage === 'section'" :id="sectionId" @back="handleSectionBack" />
    <ForgotPassword v-else-if="currentPage === 'forgot-password'" @back="switchToLogin" />
    <UserAgreement v-else-if="currentPage === 'user-agreement'" @back="switchToRegister" />
  </div>
</template>

<script>
import Login from './components/Login.vue';
import Register from './components/Register.vue';
import Home from './components/Home.vue';
import ScoreLookup from './components/ScoreLookup.vue';
import AdmissionTicketPage from './components/AdmissionTicketPage.vue';
import AdmitCardPrint from './components/AdmitCardPrint.vue';
import ExamRegisterPage from './components/ExamRegisterPage.vue';
import ExamDetailPage from './components/ExamDetailPage.vue';
import AnnouncementDetail from './components/AnnouncementDetail.vue';
import SectionDetail from './components/SectionDetail.vue';
import ForgotPassword from './components/ForgotPassword.vue';
import UserAgreement from './components/UserAgreement.vue';
export default {
  name: 'App',
  components: {
    Login,
    Register,
    Home,
    ScoreLookup,
    AdmissionTicketPage,
    AdmitCardPrint,
    AnnouncementDetail,
    ExamRegisterPage,
    SectionDetail,
    ForgotPassword,
    ExamDetailPage,
    UserAgreement,
  },
  data() {
    return {
      currentPage: 'login', // 默认显示登录页面
      announcementId: null,
      sectionId: null,
      examId: null,
    }
  },
  mounted() {
    // 初始化时检查URL哈希值
    this.checkHash();
    // 监听哈希变化
    window.addEventListener('hashchange', this.checkHash);
    
    // 保存原始的错误处理函数
    const originalErrorHandler = window.onerror;
    
    // 重写window.onerror来捕获所有错误
    window.onerror = function(message, source, lineno, colno, error) {
      if (message && message.includes('ResizeObserver loop completed with undelivered notifications')) {
        // 忽略ResizeObserver循环错误
        return true;
      }
      // 如果有原始错误处理函数，调用它
      if (originalErrorHandler) {
        return originalErrorHandler(message, source, lineno, colno, error);
      }
      // 返回false以允许默认错误处理
      return false;
    };
    
    // 同时添加error事件监听作为双重保障
    window.addEventListener('error', (event) => {
      if (event.message && event.message.includes('ResizeObserver loop completed with undelivered notifications')) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    });
    
    // 重写ResizeObserver构造函数，添加防抖动机制
    const OriginalResizeObserver = window.ResizeObserver;
    if (OriginalResizeObserver) {
      window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
        constructor(callback) {
          let debounceTimer;
          const debouncedCallback = (entries, observer) => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => callback(entries, observer), 100);
          };
          super(debouncedCallback);
        }
      };
    }
  },
  beforeUnmount() {
    // 移除事件监听
    window.removeEventListener('hashchange', this.checkHash);
  },
  methods: {
    // 检查URL哈希值来决定显示哪个页面
    checkHash() {
      const hash = window.location.hash;
      
      // 验证ID是否为有效数字
      const validateId = (id) => {
        return id && /^\d+$/.test(id);
      };
      
      if (hash === '#register') {
        this.currentPage = 'register';
      } else if (hash === '#home') {
        this.currentPage = 'home';
      } else if (hash === '#score-lookup') {
        this.currentPage = 'score-lookup';
      } else if (hash.startsWith('#announcement/')) {
        const parts = hash.split('/');
        const id = parts[1];
        if (validateId(id)) {
          this.announcementId = id;
          this.currentPage = 'announcement';
        } else {
          console.warn('无效的公告ID:', id);
          window.location.hash = 'home';
        }
      } else if (hash.startsWith('#exam-register/')) {
        const parts = hash.split('/');
        const id = parts[1];
        if (validateId(id)) {
          this.examId = id;
          this.currentPage = 'exam-register';
        } else {
          console.warn('无效的考试ID:', id);
          window.location.hash = 'home';
        }
      } else if (hash.startsWith('#ticket/')) {
        const parts = hash.split('/');
        const id = parts[1];
        if (validateId(id)) {
          this.examId = id;
          this.currentPage = 'ticket';
        } else {
          console.warn('无效的考试ID:', id);
          window.location.hash = 'home';
        }
      } else if (hash.startsWith('#admit-card/')) {
        const parts = hash.split('/');
        const id = parts[1];
        if (validateId(id)) {
          this.examId = id;
          this.currentPage = 'admit-card';
        } else {
          console.warn('无效的考试ID:', id);
          window.location.hash = 'home';
        }
      } else if (hash.startsWith('#exam-detail/')) {
        const parts = hash.split('/');
        const id = parts[1];
        if (validateId(id)) {
          this.examId = id;
          this.currentPage = 'exam-detail';
        } else {
          console.warn('无效的考试ID:', id);
          window.location.hash = 'home';
        }
      } else if (hash === '#ticket') {
        // 准考证打印列表页（无考试ID）
        this.examId = null;
        this.currentPage = 'ticket';
      } else if (hash.startsWith('#section/')) {
        const parts = hash.split('/');
        const id = parts[1];
        // section ID可以是字符串，只需要非空即可
        if (id) {
          this.sectionId = id;
          this.currentPage = 'section';
        } else {
          window.location.hash = 'home';
        }
      } else if (hash === '#forgot-password') {
        this.currentPage = 'forgot-password';
      } else if (hash === '#user-agreement') {
        this.currentPage = 'user-agreement';
      } else {
        const token = localStorage.getItem('user_access_token') || '';
        this.currentPage = token ? 'home' : 'login';
      }
    },
    // 切换到注册页面
    switchToRegister() {
      window.location.hash = 'register';
      this.currentPage = 'register';
    },
    // 切换到登录页面
    switchToLogin() {
      window.location.hash = 'login';
      this.currentPage = 'login';
    },
    // 切换到首页
    switchToHome() {
      window.location.hash = 'home';
      this.currentPage = 'home';
    },
    // SectionDetail 返回：优先返回浏览器历史中的上一页；无历史则回来源或登录/首页
    handleSectionBack() {
      // 1) 优先使用浏览器历史记录，返回上一个哈希路由
      if (window.history && window.history.length > 1) {
        window.history.back()
        return
      }
      // 2) 其次使用记录的来源页（例如：#home 或 #login）
      const from = sessionStorage.getItem('last_page') || ''
      if (from) {
        window.location.hash = from.replace('#','')
        this.currentPage = from.replace('#','')
        return
      }
      // 3) 兜底：根据登录状态返回登录或首页
      const token = localStorage.getItem('user_access_token') || ''
      if (token) {
        window.location.hash = 'home'
        this.currentPage = 'home'
      } else {
        window.location.hash = 'login'
        this.currentPage = 'login'
      }
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-text-primary);
  margin: 0;
  padding: 0;
  width: 100%;
  font-family: var(--font-family-sans);
}
</style>
